/*
 * TUMLE Halloween 2026: decorations over the shop's photos. Runs only while
 * <html> has the class tumle_halloween (snippets/tumle_campaign.liquid sets
 * it inside the campaign window).
 *   - Two ghosts hang on threads and sway; tap one and it jumps and says
 *     "Bøh!" (the tap does not open the photo zoom).
 *   - Cobwebs in two corners of the large photos (banners, product gallery,
 *     image-with-text) and a small one on product cards.
 *   - A spider bobs on its thread on the large photos.
 *   - Bats fly across the banners now and then, and a small flock flies
 *     across the whole screen shortly after load and every 18-30 seconds.
 *   - A witch on a broom flies across the screen about 6 seconds after load
 *     and every 25-40 seconds.
 * On the product gallery everything hangs on the gallery frame, not a slide,
 * so it stays put while the photos change. Decoration only (aria-hidden);
 * still under reduced motion. Styles in assets/tumle_halloween.css.
 * Loaded by layout/theme.liquid.
 */
(function () {
  if (!document.documentElement.classList.contains('tumle_halloween')) return;

  var LARGE = '.banner__media, slider-component[id^="GalleryViewer"], .image-with-text__media';
  var CARDS = '.card__media';
  var BANNERS = '.banner__media';
  var TARGETS = LARGE + ', ' + CARDS;

  var GHOST =
    '<svg viewBox="0 0 40 60" aria-hidden="true" focusable="false">' +
    '<line x1="20" y1="0" x2="20" y2="14" stroke="rgba(18,18,18,.35)" stroke-width="1"/>' +
    '<path d="M20 14c-9 0-15 7-15 16v24l5-4 5 4 5-4 5 4 5-4 5 4V30c0-9-6-16-15-16z" fill="#fff" stroke="rgba(18,18,18,.18)" stroke-width="1"/>' +
    '<ellipse cx="15.5" cy="30" rx="2" ry="3" fill="#121212"/>' +
    '<ellipse cx="24.5" cy="30" rx="2" ry="3" fill="#121212"/>' +
    '<ellipse cx="20" cy="38" rx="2.2" ry="1.6" fill="#121212"/>' +
    '</svg>';

  // Corner web: spokes and sagging rings from the bottom right corner
  // The soft shadow is a wider, faint dark copy of the threads under the
  // white ones (a CSS filter here made scrolling lag on phones)
  var WEB_PATHS =
    '<path d="M100 100 0 100M100 100 8 62M100 100 38 38M100 100 62 8M100 100 100 0"/>' +
    '<path d="M76 100 78 89 83 83 89 78 100 76"/>' +
    '<path d="M52 100 56 80 66 66 80 56 100 52"/>' +
    '<path d="M28 100 33 70 49 49 70 33 100 28"/>' +
    '<path d="M6 100 13 60 32 32 60 13 100 6"/>';
  var WEB =
    '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false" fill="none" stroke-linecap="round">' +
    '<g stroke="rgba(18,18,18,.22)" stroke-width="2.6">' + WEB_PATHS + '</g>' +
    '<g stroke="#fff" stroke-width="1.2">' + WEB_PATHS + '</g>' +
    '</svg>';

  var SPIDER =
    '<svg viewBox="0 0 40 40" aria-hidden="true" focusable="false" stroke="#121212" stroke-width="1.6" stroke-linecap="round" fill="none">' +
    '<path d="M14 18 5 12M14 21 3 21M14 24 5 30M15 26 9 36M26 18 35 12M26 21 37 21M26 24 35 30M25 26 31 36"/>' +
    '<ellipse cx="20" cy="22" rx="7" ry="8" fill="#121212" stroke="none"/>' +
    '<circle cx="20" cy="13" r="4.5" fill="#121212" stroke="none"/>' +
    '<circle cx="18.3" cy="12.5" r="1.1" fill="#ef8240" stroke="none"/>' +
    '<circle cx="21.7" cy="12.5" r="1.1" fill="#ef8240" stroke="none"/>' +
    '</svg>';

  var BAT =
    '<svg viewBox="0 0 64 28" aria-hidden="true" focusable="false">' +
    '<path class="tumle_bat__wings" d="M32 12c-3-6-9-9-16-8 3 2 4 5 3 8-4-2-9-1-13 2 4 0 7 2 8 5 4-3 10-4 18-2 8-2 14-1 18 2 1-3 4-5 8-5-4-3-9-4-13-2-1-3 0-6 3-8-7-1-13 2-16 8z" fill="#121212"/>' +
    '<circle cx="30" cy="12" r=".9" fill="#ef8240"/><circle cx="34" cy="12" r=".9" fill="#ef8240"/>' +
    '</svg>';

  function add(el, cls, html) {
    var s = document.createElement('span');
    s.className = cls;
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = html;
    el.appendChild(s);
    return s;
  }

  // A photo's decorations stop moving while the photo is off screen
  // (tumle_halloween-still), so a long page with many product cards does
  // not keep dozens of ghosts animating while you scroll
  var still =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              e.target.classList.toggle('tumle_halloween-still', !e.isIntersecting);
            });
          },
          { rootMargin: '100px 0px' }
        )
      : null;

  function decorate(el) {
    if (el.dataset.tumleHalloween) return;
    el.dataset.tumleHalloween = '1';
    if (still) still.observe(el);
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';

    add(
      el,
      'tumle_ghosts',
      '<span class="tumle_ghost tumle_ghost--big">' + GHOST + '<b class="tumle_ghost__boo">Bøh!</b></span>' +
        '<span class="tumle_ghost tumle_ghost--small">' + GHOST + '<b class="tumle_ghost__boo">Bøh!</b></span>'
    );

    if (el.matches(LARGE)) {
      var webBr = add(el, 'tumle_web tumle_web--br', WEB);
      if (el.matches('slider-component[id^="GalleryViewer"]')) alignToPhoto(el, webBr);
      add(el, 'tumle_web tumle_web--tl', WEB);
      hangFromTop(el, add(el, 'tumle_spider', '<span class="tumle_spider__thread"></span>' + SPIDER));
    } else {
      add(el, 'tumle_web tumle_web--card', WEB);
    }

    if (el.matches(BANNERS)) {
      var bats = add(el, 'tumle_bats', '');
      for (var i = 0; i < 3; i++) add(bats, 'tumle_bat tumle_bat--' + (i + 1), BAT);
    }
  }

  // A spider on the first photo of the page hangs from above the campaign
  // bar: it moves out of the photo (banners clip their photo) onto the page,
  // over the photo's left part, drawn over the bars (tumle_spider--top),
  // and its thread reaches from the photo up past the top of the page
  // (--tumle-reach). Spiders further down hang from their own photo's top.
  function hangFromTop(frame, spider) {
    function place() {
      var r = frame.getBoundingClientRect();
      var top = r.top + window.scrollY;
      if (top >= 400) return;
      var phone = window.innerWidth < 750;
      if (spider.parentNode !== document.body) {
        spider.classList.add('tumle_spider--top');
        document.body.appendChild(spider);
      }
      spider.style.top = Math.round(top) + 'px';
      spider.style.left = Math.round(r.left + window.scrollX + r.width * (phone ? 0.2 : 0.18)) + 'px';
      spider.style.setProperty('--tumle-reach', Math.max(0, Math.round(top)) + 'px');
      spider.style.setProperty('--tumle-thread', phone ? '6.5rem' : '4.5rem'); // half the photo spiders' thread
    }
    place();
    window.addEventListener('load', place);
    window.addEventListener('resize', place);
  }

  // The gallery frame runs a few pixels below the photo (space under the
  // slide list), so line the bottom web up with the photo's own bottom edge
  function alignToPhoto(frame, web) {
    function align() {
      var photo = frame.querySelector('.product__media-item .product-media-container');
      if (!photo) return;
      var gap = frame.getBoundingClientRect().bottom - photo.getBoundingClientRect().bottom;
      web.style.bottom = Math.max(0, Math.round(gap)) + 'px';
    }
    align();
    window.addEventListener('load', align);
    window.addEventListener('resize', align);
  }

  function run(root) {
    (root || document).querySelectorAll(TARGETS).forEach(decorate);
  }

  // A cobweb with a crawling spider fixed to the left edge of the screen,
  // just above where the sticky "Læg i kurv" bar sits (product pages only).
  // It does not move with the bar: --tumle-bar-h is the bar's height.
  function barWeb() {
    var bar = document.querySelector('.tum-sticky-atc');
    if (!bar || document.querySelector('.tumle_bar-web')) return;
    var web = document.createElement('span');
    web.className = 'tumle_bar-web';
    web.setAttribute('aria-hidden', 'true');
    document.body.appendChild(web);
    function size() {
      web.style.setProperty('--tumle-bar-h', bar.offsetHeight + 'px');
    }
    size();
    window.addEventListener('load', size);
    window.addEventListener('resize', size);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', barWeb);
  else barWeb();

  // Tap a spider: it climbs back up its thread and out of the screen, and
  // stays away for the rest of the visit to this page. Captured first so
  // the photo behind it does not open its zoom.
  document.addEventListener(
    'click',
    function (e) {
      var body = e.target.closest && e.target.closest('.tumle_spider svg');
      if (!body) return;
      e.preventDefault();
      e.stopPropagation();
      body.closest('.tumle_spider').classList.add('tumle_spider--gone');
    },
    true
  );

  // Tap a ghost: it jumps and says "Bøh!". Captured first so the photo
  // behind it does not open its zoom.
  document.addEventListener(
    'click',
    function (e) {
      var ghost = e.target.closest && e.target.closest('.tumle_ghost');
      if (!ghost) return;
      e.preventDefault();
      e.stopPropagation();
      ghost.classList.remove('tumle_ghost--boo');
      void ghost.offsetWidth; // restart the animation
      ghost.classList.add('tumle_ghost--boo');
      setTimeout(function () { ghost.classList.remove('tumle_ghost--boo'); }, 1400);
    },
    true
  );

  // A flock of bats across the whole screen, from a random side and height
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function flock() {
    if (document.hidden) return;
    var layer = document.createElement('div');
    layer.className = 'tumle_bat-flight';
    layer.setAttribute('aria-hidden', 'true');
    var fromRight = Math.random() < 0.5;
    if (fromRight) layer.classList.add('tumle_bat-flight--rtl');
    var count = 3 + Math.floor(Math.random() * 3);
    var baseTop = 10 + Math.random() * 50; // % of the screen height
    for (var i = 0; i < count; i++) {
      var bat = document.createElement('span');
      bat.className = 'tumle_bat-flight__bat';
      bat.style.top = baseTop + (Math.random() * 16 - 8) + 'vh';
      bat.style.width = 2.6 + Math.random() * 2.4 + 'rem';
      bat.style.animationDelay = i * (0.25 + Math.random() * 0.35) + 's';
      bat.style.animationDuration = 4.5 + Math.random() * 2 + 's';
      bat.innerHTML = BAT;
      layer.appendChild(bat);
    }
    document.body.appendChild(layer);
    setTimeout(function () { layer.remove(); }, 9000);
  }

  // Witch on a broom, drawn facing left (broom tail on the right)
  var WITCH =
    '<svg viewBox="0 -18 130 90" aria-hidden="true" focusable="false">' +
    '<path d="M6 52 102 40" stroke="#6b4a2b" stroke-width="3.5" stroke-linecap="round"/>' +
    '<path d="M98 38 126 28 124 40 128 50 100 46z" fill="#ef8240"/>' +
    '<path d="M100 39 118 34M101 44 120 46" stroke="#b85a1f" stroke-width="1.2"/>' +
    '<path d="M44 48 64 22 80 26 84 46z" fill="#121212"/>' +
    '<path d="M84 46 96 30 98 44z" fill="#121212"/>' +
    '<path d="M58 46 50 60 56 60" stroke="#121212" stroke-width="3" fill="none" stroke-linecap="round"/>' +
    '<circle cx="64" cy="16" r="7" fill="#121212"/>' +
    '<path d="M52 12 80 10 62 -14 66 4z" fill="#121212"/>' +
    '<path d="M54 11 78 9.5" stroke="#ef8240" stroke-width="2"/>' +
    '<path d="M58 20c-6 4-8 10-6 14" stroke="#ef8240" stroke-width="2.4" fill="none" stroke-linecap="round"/>' +
    '</svg>';

  function witch() {
    if (document.hidden) return;
    var layer = document.createElement('div');
    layer.className = 'tumle_witch-flight';
    layer.setAttribute('aria-hidden', 'true');
    if (Math.random() < 0.5) layer.classList.add('tumle_witch-flight--ltr');
    var w = document.createElement('span');
    w.className = 'tumle_witch-flight__witch';
    w.style.top = 12 + Math.random() * 45 + 'vh';
    w.innerHTML = '<span class="tumle_witch-flight__bob">' + WITCH + '</span>';
    layer.appendChild(w);
    document.body.appendChild(layer);
    setTimeout(function () { layer.remove(); }, 9000);
  }

  function scheduleFlocks() {
    if (REDUCED) return;
    setTimeout(flock, 1500);
    (function next() {
      setTimeout(function () { flock(); next(); }, 18000 + Math.random() * 12000);
    })();
    setTimeout(witch, 6000);
    (function nextWitch() {
      setTimeout(function () { witch(); nextWitch(); }, 25000 + Math.random() * 15000);
    })();
  }

  if (document.readyState === 'complete') scheduleFlocks();
  else window.addEventListener('load', scheduleFlocks);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  // Cards and galleries that load later (filters, recommendations, variants)
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      r.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches(TARGETS)) decorate(n);
        if (n.querySelectorAll) run(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
